import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const departmentsApi = createApi({
  reducerPath: 'departmentsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getDepartments: builder.query({
      query: () => ({
        url: urls.departments,
      }),
    }),
    getDepartment: builder.query({
      query: (id) => ({
        url: urls.departmentDetail(id),
      }),
    }),
    saveDepartment: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.departmentDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.departmentDetail(req.id),
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
  }),
});

export const {
  useGetDepartmentsQuery,
  useGetDepartmentQuery,
  useSaveDepartmentMutation,
} = departmentsApi;
